import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { giantAnimations } from '../admin-layout/animations';
import { GiantConfigService } from '../admin-layout/services/config-service';
import { Router } from '@angular/router';
import { UserRepository } from 'src/app/repositories/user/UserRepository';
import { GiantSnackBarService } from 'src/app/shared/utils/giant-snack-bar';

import { Login } from 'src/app/models/login.model';

@Component({
    selector: 'forgetpassword',
    templateUrl: 'forgetpassword-enter-resetcode.html',
    styleUrls: ['forgetpassword.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: giantAnimations
})
export class EnterPasswordResetCodeComponent implements OnInit {
    resetCodeForm: UntypedFormGroup;

    LoginModel = new Login();

    navObj : any[]= [{ id: 'pages', title: 'Pages', type: 'group', icon: 'pages', children: [] }];

    constructor(
        private _giantConfigService: GiantConfigService,
        private _formBuilder: UntypedFormBuilder,
        private _router: Router,
        private _userRepository: UserRepository,
        private _giantSnackBarService :GiantSnackBarService
    ) {
        // Configure the layout
        debugger;
        this._giantConfigService.config = {
            layout: {
                navbar: {
                    hidden: true
                },
                toolbar: {
                    hidden: true
                },
                footer: {
                    hidden: true
                },
                sidepanel: {
                    hidden: true
                }
            }
        };
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------

    /**
     * On init
     */
    ngOnInit(): void {
        debugger;
        this.resetCodeForm = this._formBuilder.group({
            passwordResetCode: ['', [Validators.required]],            
        });
    }

    VerifyResetCode(form: any) {
        debugger;
        this.LoginModel.PasswordResetCode = form.value.passwordResetCode;
        this.LoginModel.Email = localStorage.getItem("UserEmail");
        localStorage.setItem("PasswordResetCode", form.value.passwordResetCode);

        this._userRepository.VerifyPasswordResetCode(this.LoginModel).subscribe((res: any) => {
            debugger;
            if (res._obj.ResponseCode == 1) {
                this._router.navigate(['/resetpassword'])
                this._giantSnackBarService.snackbarSuccess(res._obj.ResponseMessage);                
              }
              if (res._obj.ResponseCode == 0) {
                this._giantSnackBarService.snackbarError(res._obj.ResponseMessage);
              }            
        });

    }
}
